import { render } from "./SickDaysEditModal.vue?vue&type=template&id=07359c79&scoped=true"
import script from "./SickDaysEditModal.vue?vue&type=script&lang=js"
export * from "./SickDaysEditModal.vue?vue&type=script&lang=js"

import "./SickDaysEditModal.vue?vue&type=style&index=0&id=07359c79&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07359c79"]])

export default __exports__